import { defineMessages } from 'react-intl'

const messages = defineMessages({
  modalTitle: {
    id: 'ContentDateModal.modalTitle',
    description: 'Texto para el titulo del modal para la seleccion de fechas',
    defaultMessage: 'Cambiar el rango de fechas'
  },
  modalFrom: {
    id: 'ContentDateModal.modalFrom',
    description: 'Texto para seleccionar la fecha inicial',
    defaultMessage: 'Desde'
  },
  modalTo: {
    id: 'ContentDateModal.modalTo',
    description: 'Texto para seleccionar la fecha final',
    defaultMessage: 'Hasta'
  },
  modalYear: {
    id: 'ContentDateModal.modalYear',
    description: 'Texto para seleccionar la fecha cuando solo es posible seleccionar un año',
    defaultMessage: 'Año'
  },
  modalClose: {
    id: 'ContentDateModal.modalClose',
    description: 'Texto para el boton de cerrar el modal',
    defaultMessage: 'Cerrar'
  },
  modalApply: {
    id: 'ContentDateModal.modalApply',
    description: 'Texto para el boton de aplicar del modal',
    defaultMessage: 'Aplicar'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentDateModal/messages.js